import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[MatchRoom] Uncaught render error', error, info.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <div className="min-h-screen flex items-center justify-center bg-surface-900 p-6">
        <div className="max-w-lg w-full glass rounded-xl p-6 border border-error/30">
          <h1 className="text-lg font-semibold text-white mb-2">Something went wrong</h1>
          <p className="text-sm text-surface-400 mb-4">
            MatchRoom hit a runtime error and could not render. Try a hard refresh. If the page
            stays blank, check the browser console for details.
          </p>
          <p className="text-xs font-mono text-error/90 bg-error/10 rounded p-3 mb-4 break-all">
            {this.state.error.message}
          </p>
          <button
            type="button"
            className="text-sm text-brand-400 hover:text-brand-300"
            onClick={() => window.location.reload()}
          >
            Reload page
          </button>
        </div>
      </div>
    );
  }
}
